// extracted by mini-css-extract-plugin
export default {"select-pill-wrapper":"Local_select-pill-wrapper__VPsV3","arrow-right-icon":"Local_arrow-right-icon__Hp1we","check-all-ufs":"Local_check-all-ufs__whmmX"};